// Tiny shared helper used next to every <input type="date"> in BOMS so
// the picked date is also shown as a human day-of-week label
// ("Wed 14 May") — native date pickers don't surface that.
//
// Accepts the value an <input type="date"> emits ("YYYY-MM-DD") OR an ISO
// timestamp OR a JS Date. Returns '' for invalid / empty input so callers
// can drop the result inline without conditional rendering.

const DAYS_LONG = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const DAYS_SHORT = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function parseToDate(value) {
    if (!value) return null;
    if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
    const s = String(value);
    // YYYY-MM-DD from <input type="date"> — interpret as local midnight
    // so the day-of-week computation isn't wrong for users in eastern TZs
    // when the source value is "2026-05-14".
    const ymd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (ymd) {
        const d = new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
        return Number.isFinite(d.getTime()) ? d : null;
    }
    const d = new Date(s);
    return Number.isFinite(d.getTime()) ? d : null;
}

// "Wed" / ""
export function dowShort(value) {
    const d = parseToDate(value);
    return d ? DAYS_SHORT[d.getDay()] : '';
}

// "Wednesday" / ""
export function dowLong(value) {
    const d = parseToDate(value);
    return d ? DAYS_LONG[d.getDay()] : '';
}

// "Wed 14 May" / "" — used in tight UI like next to a date input.
export function dowDateShort(value) {
    const d = parseToDate(value);
    if (!d) return '';
    return `${DAYS_SHORT[d.getDay()]} ${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
}

// "Wednesday 14 May 2026" / "" — for places with more horizontal room.
export function dowDateLong(value) {
    const d = parseToDate(value);
    if (!d) return '';
    return `${DAYS_LONG[d.getDay()]} ${d.getDate()} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`;
}
